import { useRecoilValue } from 'recoil';
import { allVennDailyPrivateAssetReturnNames } from 'venn-state';
import { getTextThemeProvider } from 'venn-ui-kit';

export const useVennDailyPrivateAssetDisclosure = (): string | undefined => {
  const vdparNames = useRecoilValue(allVennDailyPrivateAssetReturnNames);
  const { vdparName, AppTitle } = getTextThemeProvider();

  if (vdparNames.length === 0) {
    return undefined;
  }

  return `
### **${vdparName} Disclosures**

These returns may appear individually or within portfolios and benchmarks in this report. ${vdparName} use historical data and relationships to make estimates. These estimates will not always predict future results and have inherent limitations. This report includes ${vdparName}, which are returns modeled using cohort cash flow data and a public market proxy. Please see ${AppTitle} help center for more information:

${vdparNames.map((name) => `- ${name}`).join('\n')}
`;
};
